import styled from '@emotion/styled';

import { BreakPointToken } from '../../hooks/useMediaQuery';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

const {
	spacing: {
		size_12px: { height: size_12 },
		size_16px: { height: size_16 }
	}
} = tokens;

export const HolidayNav = styled.div`
	width: 100%;
	overflow: auto;
	@media (min-width: ${BreakPointToken.MdMin}px) {
		overflow: visible;
	}

	-ms-overflow-style: none; /* for Internet Explorer, Edge */
	scrollbar-width: none; /* for Firefox */
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const HolidayNavList = styled.ul`
	display: flex;
	list-style: none;
	margin: 2px 0 0 0;
	padding: 0;
`;

export const HolidayNavListItem = styled.li`
	margin-top: -${size_12}px;
	flex: 0 0 auto;

	+ li {
		margin-inline-start: ${size_16}px;
	}
`;
